module.exports = __webpack_public_path__ + "img/dsci0028.e81ed1d2.jpg";